import { EmployeeRole } from '@/api/apis/resources';

export const rolesWithOrganField = [
  EmployeeRole.RetrievalSurgeon,
  EmployeeRole.ClinicalSpecialist,
  EmployeeRole.OrganLeadership,
  EmployeeRole.OrganManagement,
  EmployeeRole.ClinicalAuditor,
];
